import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { SupplierManagementInjection } from "features/supplierManagement/di/SupplierManagmentInjection";
import isString from "lodash/isString";
import isUndefined from "lodash/isUndefined";
import { injectable } from "tsyringe";
import { avoidDuplicate } from "utils/helpersInTs/helpersInTs";
import { SupplierActionRequestEntity } from "../entities/action/SupplierActionRequestEntity";
import { SupplierDetailResponseEntity } from "../entities/detail/SupplierDetailResponseEntity";
import { SupplierResponseEntity } from "../entities/SupplierResponseEntity";
import { SupplierRequestEntity } from "../entities/SupplierResquestEntity";
import { ISupplierManagementRepository } from "../repositories/ISupplierManagementRepository";

@injectable()
export class SupplierManagementUseCase {
  private supplierRepo: ISupplierManagementRepository;

  constructor() {
    this.supplierRepo = SupplierManagementInjection.getRepo();
  }

  private adjustBody(
    body: SupplierActionRequestEntity,
    detailInfo: SupplierDetailResponseEntity
  ) {
    let renderedBody = Object.keys(body)?.filter(
      (item) =>
        !Array.isArray(body[item]) &&
        item !== "id" &&
        item !== "configuration" &&
        !isUndefined(
          avoidDuplicate(detailInfo[item]?.toString(), body[item]?.toString())
        )
    );
    let afterBody = {
      id: body["id"],
      ...renderedBody?.reduce(
        (a, v) => ({ ...a, [v]: body[v]?.toString() }),
        {}
      ),
      configuration: isUndefined(body["configuration"])
        ? undefined
        : isString(body["configuration"])
        ? JSON.parse(body["configuration"] as string)
        : body["configuration"],
    } as typeof body;
    return afterBody;
  }

  async getList(
    params: SupplierRequestEntity
  ): Promise<ListBaseApiResponseModel<SupplierResponseEntity>> {
    return await this.supplierRepo.getList(params);
  }

  async getB2BSupplierList(
    params: SupplierRequestEntity
  ): Promise<ListBaseApiResponseModel<SupplierResponseEntity>> {
    return await this.supplierRepo.getB2BSupplierList(params);
  }

  async getDetail(params: {
    id: string;
  }): Promise<BaseApiResponseModel<SupplierDetailResponseEntity>> {
    return await this.supplierRepo.getDetail(params);
  }

  async createSupplier(
    body: SupplierActionRequestEntity,
    detailInfo: SupplierDetailResponseEntity
  ): Promise<BaseApiResponseModel<SupplierResponseEntity>> {
    const updatedBody = this.adjustBody(body, detailInfo);
    return await this.supplierRepo.createSupplier(updatedBody);
  }

  async updateSupplier(
    body: SupplierActionRequestEntity,
    detailInfo: SupplierDetailResponseEntity
  ): Promise<BaseApiResponseModel<SupplierResponseEntity>> {
    const updatedBody = this.adjustBody(body, detailInfo);
    return await this.supplierRepo.updateSupplier(updatedBody);
  }

  async deleteSupplier(params: {
    id: string;
  }): Promise<BaseApiResponseModel<SupplierResponseEntity>> {
    return await this.supplierRepo.deleteSupplier(params);
  }
}
